



























































































































































































































import moment from "moment/moment";
import { mixins } from "vue-class-component";
import { Component } from "vue-property-decorator";
import { Watch } from "vue-property-decorator";
import MyMixin from "@/mixins/datemixin";
import { Site } from "@/shared/Site";
import DateType from "@/shared/DateType";
import ExpandableDateChooser from "@/components/expansion/expandableDateChooser.vue";
import ExpandableListeSites from "@/components/expansion/expandableListeSites.vue";
import ExpandableTotal from "@/components/expansion/expandableTotal.vue";
import PdfReport from "@/shared/pdfReport";
import PdfViewer from "@/components/pdf-viewer.vue";
import NumberTmpl from "@/ui-component/number.vue";
import CoffreMixin from "@/mixins/coffreUtils";
import VueJsonToCsv from "vue-json-to-csv";
import MobileMixin from "@/mixins/mobileMixin";
import RapportMixin from "@/mixins/rapportMixin";
import { TypeRapport, Rapport } from "@/shared/Rapport";
import ErrorMixin from "@/mixins/errorMixins";

@Component({
  components: {
    ExpandableDateChooser,
    ExpandableListeSites,
    ExpandableTotal,
    PdfViewer,
    NumberTmpl,
    VueJsonToCsv,
  },
})
export default class ComptageCaisses extends mixins(
  MyMixin,
  CoffreMixin,
  MobileMixin,
  RapportMixin,
  ErrorMixin
) {
  public action: string = "";
  public dateType: DateType = new DateType();
  public selectedSites: Site[] = new Array();
  public totalData = { reel: 0, theorique: 0, diff: 0, isTva: false };
  public recus = new Array();
  public loadData = false;
  // TODO : utilse ?
  public search = "";
  public showRecu = false;
  public showPdf: boolean = false;
  public src: string = "";
  public pdfReport: PdfReport = new PdfReport();
  public openedPans = -1;
  public headers = new Array();
  public values: { [key: string]: { [key: string]: any } } = {};
  public decades = new Array();
  public options = {
    sortBy: ["validationHorodatage"],
  };
  public monrapport: Rapport = new Rapport();

  @Watch("$route.params.action", { immediate: false })
  public onPropertyChangedLabel(value: any, oldValue: any) {
    // console.log(value);
    this.updateParams();
  }

  public mounted() {
    // console.log("comptages");
    this.updateParams();
    this.criteres.start = this.formatDateSend(new Date());
    const dateFin = moment().add("d", 1).toDate();
    this.criteres.end = this.formatDateSend(dateFin);
    this.criteres.site = this.sites[0].restaurantId;
    this.selectedSites = new Array();
    this.selectedSites.push(this.sites[0]);
    this.filterDecades();
  }
  /**
   * mise a jour des parametres pour affichage du bon recu
   */
  public updateParams() {
    this.recus = new Array();
    this.action = this.$route.params.action;
    this.criteres.action = this.action;

    switch (this.action) {
      case "prelevementsDeclares":
      case "sessionsDeclarees":
        this.headers = this.getComptageCaisseHeaders();
        break;
      case "mouvementsFinancier&mouvement=DEPENSE":
      case "mouvementsFinancier&mouvement=RECETTES":
      case "mouvementsFinancier&mouvement=EQUILIBRE":
        this.headers = this.getMouvementsHeaders();
        break;
      case "vidagesCompte":
        this.headers = this.getVidagesHeaders();
        break;
    }
  }
  /**
   * methode de mise a jour de la date modifié dans l'expandable panel
   * @param date {DateType} - la date dans le format du datepicker
   */
  public updateDate(date: DateType) {
    this.dateType = date;
    if (date.dateFin && date.dateDebut) {
      this.criteres.start = this.formatDateSend(date.dateDebut);
      const dateFin = moment(date.dateFin).add("d", 1).toDate();
      this.criteres.end = this.formatDateSend(dateFin);
    }
  }
  public getDetails(event: any) {
    if (!event.value) {
      return;
    }
    this.values["total"] = { CRT: 0, ANCV: 0 };
    const reglements = event.item.tiroirReglements;
    this.extractQte(reglements, "CRT");
    this.extractQte(reglements, "ANCV");
    if (this.values.CRT) {
      this.values.CRT.sort((a: any, b: any) => {
        return a.value - b.value;
      });
    }
    if (this.values.ANCV) {
      this.values.ANCV.sort((a: any, b: any) => {
        return a.value - b.value;
      });
    }
  }
  /**
   * methode  de mise a jour du site selectionné
   * @param site {Site} - le site à selectionner
   */
  public addSite(site: Site) {
    this.selectedSites = [];
    this.selectedSites.push(site);
    this.criteres.site = site.restaurantId;
  }
  /**
   * methode permettant de faire disparaitre le dialogue contenant le rapport
   */
  public hide(target: any) {
    this.showRecu = false;
  }
  /**
   * méthode de récueparation des recus concernés
   */
  public getRecus() {
    this.loadData = true;
    // console.log(this.criteres)
    this.$store.dispatch("analyses/getRecusCaisses", this.criteres).then(
      (data: any) => {
        if (data.code === 2) {
          this.recus = data.response;
          this.orderData();
        } else {
          this.setErrorFromTxt(data.response.toString());
          this.loadData = false;
        }
        // this.$store.dispatch("login/setLoading", false);
      },
      (error: any) => {
        console.log(error);
        this.setErrorFromTxt(error.toString());
        this.loadData = false;
        // this.$store.dispatch("login/setLoading", false);
      }
    );
  }
  /**
   * methode de récuperation et d'affichage d'un recu particulier
   */
  public getOne(item: any) {
    // console.log(item);
    this.$store.dispatch("analyses/getOneRecu", item.id).then(
      (data: any) => {
        // console.log(data);
        this.showTicket(data, item.id);
        // this.monRecu = data;
      },
      (error: any) => {
        console.log(error);
        this.setErrorFromTxt(error.toString());
        this.loadData = false;
      }
    );
  }

  public getMyClass(recu: any) {
    // console.log(recu);
    if (recu.type === "RECU_FIN_SESSION_ATTENTE_CONTRE_SIGNATURE") {
      return "missing";
    }
  }
  /**
   * methode permettant de sortir un rapport de decade correspondant à un vidage CRT ou ANCV (buffalo)
   */
  public makeRapport(format: string, item: any) {
    // const typeReport: TypeRapport = {className: "", localisedTitle: ""};
    let rep: TypeRapport = { className: "", localisedTitle: "" };

    if (item.ruleDescription.includes("CRT")) {
      rep = this.decades.filter((rap: TypeRapport) =>
        rap.className.includes("CRT")
      )[0];
    } else if (item.ruleDescription.includes("ANCV")) {
      rep = this.decades.filter((rap: TypeRapport) =>
        rap.className.includes("ANCV")
      )[0];
    }

    this.monrapport.setDateDebut(new Date(item.dateFiscale));
    this.monrapport.setDateFin(new Date(item.dateFiscale));
    this.monrapport.typeRapport = rep;
    this.monrapport.lSites.push(this.selectedSites[0]);

    this.$store.dispatch("rapport/updateRapport", this.monrapport);
    this.genererRapport("PDF");
  }
  /**
   * affichage du pdf du recu selectionné
   */
  private showTicket(ticketpdf: any, ticketId: string) {
    // .loadTicket = false;
    const blob = new Blob([ticketpdf.data], {
      type: ticketpdf.headers["content-type"],
    });
    const bloburl = (window.URL || window || {}).createObjectURL(blob);
    this.src = bloburl;
    this.pdfReport.src = bloburl;
    (this.pdfReport.titre = ticketId + ".pdf"), (this.showPdf = true);
    // if (this.isIframe()) {
    this.showRecu = true;
    // }
  }
  /**
   * methode permettant d'extraire du tag les valeur / quanttité des crt, ancv et autres
   * @param reglements reglements : le tiroirReglement du comptage selectionné
   * @param type - String - le type de reglement recherché
   */
  private extractQte(reglements: any, type: string) {
    const crt = reglements.filter((reglement: any) => {
      if (reglement.libelle === type) {
        return reglement;
      }
    });
    this.values[type] = new Array();
    // console.log(this.values);
    const encodedCRT = crt[0].tag.split("values=");
    if (encodedCRT.length === 2) {
      const keyValues = decodeURIComponent(encodedCRT[1]).split("&");
      // console.log(keyValues);
      return keyValues.map((keyVal: any) => {
        const result = keyVal.split("=");
        this.values.total[type] += parseFloat(result[0]) * parseInt(result[1]);
        this.values[type].push({
          value: parseFloat(result[0]),
          quantite: result[1],
        });
      });
    }
  }

  private filterDecades() {
    const allreps = this.$store.getters["rapport/allReports"];
    const keys = Object.keys(allreps);
    if (keys.includes("FINANCES")) {
      const finances = allreps.FINANCES;
      this.decades = finances.filter((rap: any) =>
        rap.className.includes("Decade")
      );
      // console.log(this.decades);
    }
  }

  private orderData() {
    this.totalData.reel = 0;
    this.totalData.theorique = 0;
    if (this.action.includes("Declare")) {
      this.recus.map((comptage: any) => {
        this.totalData.isTva = false;
        let reel = 0;
        let theo = 0;
        if (this.action.includes("sessions")) {
          comptage.tiroir_REGLEMENTs.map((rgl: any) => {
            if (rgl.libelle !== "REPAS EMPLOYE") {
              reel += rgl.totalReel;
              theo += rgl.totalTheorique;
            }
          });
        } else {
          comptage.tiroir_PRELEVEMENTs.map((rgl: any) => {
            // TODO : a modifier! le theorique recu est toujours à 0
            reel += rgl.totalReel;
            theo += rgl.totalTheorique;
          });
        }
        comptage.reel = reel;
        comptage.theo = theo;
        comptage.diff = reel - theo;
        this.totalData.reel += reel;
        this.totalData.theorique += theo;
      });
    } else {
      if (this.action.includes("mouvements")) {
        this.totalData.isTva = true;
      } else {
        this.totalData.isTva = false;
      }
      let reel = 0;
      let theo = 0;
      let anomalie = 0;
      this.recus.map((recu: any) => {
        // console.log(recu);
        reel += recu.montant1;
        theo += recu.montant0;
        anomalie += recu.montant2;
      });
      // console.log(reel, theo, anomalie);
      this.totalData.theorique = theo;
      this.totalData.reel = reel;
    }
    if (this.totalData.isTva) {
      this.totalData.diff = this.totalData.theorique + this.totalData.reel;
    } else {
      this.totalData.diff = this.totalData.theorique - this.totalData.reel;
    }
    this.openedPans = 2;

    // console.log(this.totalData);
    this.loadData = false;
  }

  get sites(): any {
    return this.$store.getters["login/sites"];
  }
}
